import { createSlice } from '@reduxjs/toolkit'

const initialState: any = {
}

const jobDetailsSlice = createSlice({
    name: 'job',
    initialState,
    reducers: {
        setJobDetails: (state, action) => {
            return { ...state, ...action.payload };
        }
    },
});

export const { setJobDetails } = jobDetailsSlice.actions;

export default jobDetailsSlice.reducer